import React, { Component } from 'react';
import './style.css';
import { getFeatureModuleListAction, getHomePageListAction, getTenantAccountAccessAction, postHomeDefaultPageAction } from '../../actions';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { isApiCallSuccess } from '../../selectors';
import { message, Spin } from 'antd';
import { Button } from '@material-ui/core';

class SetAccountsDefaultPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            enableToast: false,
            toastStatus: "",
            toastMsg: "",
            featureList: [],
            accountAccessData: [],
            pageListAllData: [],
            selectedDefaultPages: {}, // Initialize an empty object to hold the selected default pages
            loading: true // Add loading state
        };
    }

    componentDidMount() {
        this.getDefaultPageAccess();
    }

    async getDefaultPageAccess() {
        let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
        const { authToken } = isAuthenticated;
        const { tenantId, userId, getHomePageListAction } = this.props;

        // Fetch the feature list
        let featureList = await this.getFeatureModuleList(tenantId, authToken, userId);
        console.log("getFeatureModuleList", featureList);

        // Set the feature list in the state
        this.setState({ featureList: featureList });
        console.log("featureList", featureList);

        // Fetch account access data
        await this.getAccountAccess(tenantId, authToken, userId);
        console.log("accountAccessData", this.state.accountAccessData);

        // Fetch home page list data
        let { responseCode: { status = "", msg }, response } = await getHomePageListAction({ tenantId, authToken, userId });
        let pageListAllData = [];
        if (isApiCallSuccess(status) && response && response.length > 0) {
            pageListAllData = response.map(item => {
                const { tenantId, defaultPage } = item;
                const tenant = this.state.accountAccessData.find(acc => acc.tenantId === tenantId);
                const feature = featureList.find(feature => feature.attributeId === defaultPage);
                return {
                    tenantId: tenantId,
                    tenantName: tenant ? tenant.tenantName : '',
                    roleName: tenant ? tenant.roleName : '',
                    defaultPage: defaultPage,
                    defaultPageName: feature ? feature.attributeName : ''
                };
            });


            // Remove duplicate entries based on tenantId
            const uniqueTenantIds = new Set();
            pageListAllData = pageListAllData.filter(item => {
                if (uniqueTenantIds.has(item.tenantId)) {
                    return false;
                } else {
                    uniqueTenantIds.add(item.tenantId);
                    return true;
                }
            });
            console.log("pageListAllData", pageListAllData);
            this.setState({ pageListAllData: pageListAllData, loading: false }); // Update loading state to false
        }
        else {
            message.error(msg)
            this.setState({ loading: false }); // Update loading state to false even if there is an error
        }
    }

    async getFeatureModuleList(tenantId, authToken, userId) {
        const { getFeatureModuleListAction } = this.props;
        let featureModuleData = [];
        let params = {
            type: 'module',
            userId: userId
        };
        let { responseCode: { status = "" }, responseList } = await getFeatureModuleListAction({ tenantId, authToken, userId, params });
        if (isApiCallSuccess(status) && responseList && responseList.length > 0) {
            featureModuleData = responseList;
        }
        return featureModuleData;
    }

    async getAccountAccess(tenantId, authToken, userId) {
        try {
            const { getTenantAccountAccessAction } = this.props;
            const params = { tenantHierarchy: userId };
            const { responseCode: { status = "", msg }, responseList } = await getTenantAccountAccessAction({ tenantId, authToken, userId, params });

            if (isApiCallSuccess(status)) {
                this.setState({ accountAccessData: responseList });
                message.success(msg);
            } else {
                message.error(msg);
                console.error("Failed to update profile:", msg);
            }
        } catch (error) {
            console.error("Error updating user profile:", error);
        }
    }

    handleDropdownChange = (tenantId, event) => {
        const selectedPage = event.target.value;
        this.setState(prevState => ({
            selectedDefaultPages: {
                ...prevState.selectedDefaultPages,
                [tenantId]: selectedPage
            }
        }));
    };

    formatDefaultPagesRequest = () => {
        const { selectedDefaultPages } = this.state;
        const defaultPagesList = Object.keys(selectedDefaultPages).map(tenantId => ({
            tenantId: parseInt(tenantId, 10),
            defaultPage: parseInt(selectedDefaultPages[tenantId], 10)
        }));
        return { defaultPagesList };
    };

    handleSave = async () => {
        const defaultPagesRequest = this.formatDefaultPagesRequest();
        console.log("Formatted Default Pages Request:", defaultPagesRequest);

        try {
            let isAuthenticated = JSON.parse(localStorage.getItem('AuthData'));
            const { authToken } = isAuthenticated;
            const { tenantId, userId, postHomeDefaultPageAction } = this.props;

            let payload = { defaultPagesRequest };

            const params = { addup: "auto" };

            const { responseCode: { status = "", msg } } = await postHomeDefaultPageAction({ tenantId, authToken, userId, payload, params });

            if (isApiCallSuccess(status)) {
                message.success(msg)
                message.success("Changes saved successfully!");
            } else {
                message.error(msg)
                console.error("Failed to update Pages:", msg);
            }
        } catch (error) {
            console.error("Error updating user Pages:", error);
        }
    };

    handleCancel = () => {
        this.setState({ selectedDefaultPages: {} });
        message.info("Changes have been reset.");
    };

    getUniqueOptions = (tenantId) => {
        const { featureList } = this.state;
        const options = featureList
            .filter(featureItem => featureItem.tenantId == tenantId)
            .flatMap(featureItem => featureItem.module);

        const uniqueOptions = Array.from(new Set(options.map(option => option.attributeId)))
            .map(id => options.find(option => option.attributeId === id));

        return uniqueOptions;
    };

    render() {
        const { loading, pageListAllData } = this.state;

        if (loading) {
            return (
                <div className="loader-container mx-auto py-4">
                    <Spin size="large" />
                </div>
            );
        }
        return (
            <div className="default-page-adj container">
                {pageListAllData.length > 0 ? (
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Account</th>
                                <th>Role</th>
                                <th>Select Default Page</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pageListAllData.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.tenantName}</td>
                                    <td>{item.roleName}</td>
                                    <td>
                                        <select className="dropdown" defaultValue={item.defaultPage} onChange={(e) => this.handleDropdownChange(item.tenantId, e)}>
                                            <option value="">Select</option>
                                            {this.getUniqueOptions(item.tenantId).map(option => (
                                                <option key={option.attributeId} value={option.attributeId}>
                                                    {option.attributeName}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="no-data text-center pb-4">No Data Available</div>
                )}
                {pageListAllData.length > 0 && ( // Conditionally render save button
                    <div className="button-container-default-page">
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleSave}
                            style={{ marginLeft: '10px' }}
                        >
                            Save
                        </Button>
                    </div>
                )}
            </div>

        );
    }
}

export default connect(
    state => {
        return {
            getUserPermissionList: get(state, 'app.getUserPermissionList', []),
            preSignInResponseList: get(state, 'app.preSignInData.responseList', []),
            preSignInState: get(state, 'app.preSignInState', {}),
            signInData: get(state, 'app.signInData', {}),
            configurationData: get(state, 'app.configurationData.responseList', []),
            tenantId: get(state, 'app.preSignInState.tenantId', ''),
            userId: get(state, 'app.preSignInData.userId', ''),
        };
    },
    {
        getFeatureModuleListAction,
        getHomePageListAction,
        getTenantAccountAccessAction,
        postHomeDefaultPageAction
    }
)(SetAccountsDefaultPage);
